import {
  React,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import ReactDatePicker from 'react-datepicker';
import { Link, useNavigate } from 'react-router-dom';
import setUiMessage from '../../../Utilities/Tostify';
import { post } from '../../Auths/AuthToken';
import ColorPalette from './ColorPalette';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import RecurrencePopup from './RecurrencePopup';
import { format, getDate, getDay, isBefore } from 'date-fns';
import {
  DEFAULT_API_URL,
  DEFAULT_DATE_FORMATE,
  DEFAULT_LOCAL_PATH,
} from '../../../constents';
import TimeSlot from './TimeSlot';

import GroupAppPatPopUp from './GroupAppPatPopUp';
import getValidTime, { getTimeInIntervel } from '../../../Utilities/makeTime';
import ConfirmDialog from '../../../Utilities/ConfirmDialog';
import { handleAppStatus } from '../../../httpdata/appointmentsdata';
import AppCalander from './AppCalander';
import ViewAlertPopup from '../../Patient/ViewAlertPopup';
import IntakeFormsPopup from './IntakeFormsPopup';
// import IntakeFormsViewer from './IntakeFormsViewer';
import AlertDialog from '../../../Utilities/AlertDialog';
import { useDispatch, useSelector } from 'react-redux';

import {
  setGrpApp,
  setGrpAppArivedPats,
  setGrpAppPats,
  setGrpAppPatsNull,
  setPatAlertData,
} from '../../../redux/slices/scheduler/appointmentSlice';
import { setSeltSerchPat } from '../../../redux/slices/patient/patientSlice';
import {
  defSchedTab,
  handleGlobalReload,
} from '../../../redux/slices/appSlice';
import Button from '../../Button';

function AppPopup(props) {
  const { handleClose, handleOpenPatSerch } = props;

  const dispatch = useDispatch();
  const { user } = useSelector((store) => store.auth);
  const { globalReload, defaultTimeFormat } = useSelector((store) => store.app);
  const {
    isCheckoutProcess,
    patAlertData,
    recurPopupSataus,
    bookNewApp,
    appReschedule,
    grpAppPats,
    grpApp,
    globalAppId,
    patSrchDiasbled,
  } = useSelector((store) => store.appointment);
  const { selectedSerchPat } = useSelector((store) => store.patient);

  const [allDataSet, setAllDetaSet] = useState([]);

  const [selPatForApp, setSelPatForApp] = useState('');
  const [selPatName, setSelPatName] = useState('');
  const [selPatType, setSelPatType] = useState('');
  const [selNewPatType, setSelNewPatType] = useState('');
  const [enableScr, setEnableScr] = useState(false);

  const [telemedicine, setTelemedicine] = useState('0');

  const [recurrencePoup, setRecurrencePopup] = useState(false);
  const [recurrence, setRecurrence] = useState(false);
  const [recurranceFormData, setRecurranceFormData] = useState(false);

  const [grpAppOnAppPopup, setGrpAppOnAppPopup] = useState(false);
  const [grpAppChkBox, setGrpAppChkBox] = useState(false);

  const [allLocation, setAllLocation] = useState([]);
  const [location, setLocation] = useState(0);
  const [allLocDataSet, setAllLocDataSet] = useState([]);

  const [allRresource, setAllResource] = useState([]);
  const [resource, setResource] = useState(0);

  const [allProvider, setAllProvider] = useState([]);
  const [provider, setProvider] = useState(0);

  const [appDate, setAppDate] = useState(new Date());
  const [appDatePickerIsOpen, setAppDatePickerIsOpen] = useState(false);
  const [colorPalette, setColorPalette] = useState(false);
  const [appColor, setAppColor] = useState();
  const [closeDay, setCloseDay] = useState([]);
  const [holidayList, setHolidayList] = useState([]);
  const [appMinTime, setAppMinTime] = useState(null);
  const [appMaxTime, setAppMaxTime] = useState(null);
  const [providersBreak, setProvidersBreak] = useState([]);

  const [appTime, setAppTime] = useState(null);
  const [appTimePickerIsOpen, setAppTimePickerIsOpen] = useState(false);
  const [timeSlotPopup, setTimeSlotPopup] = useState(false);

  const [typeOfVisitList, setTypeOfVisitList] = useState([]);
  const [typeOfVisit, setTypeOfVisit] = useState('');

  const [duration, setDuration] = useState(0);
  const [durationText, setDurationText] = useState(15);

  const [allTypeOfPayment, setAllTypeOfPayment] = useState(0);
  const [typeOfPayment, setTypeOfPayment] = useState(0);

  const [pcp, setPcp] = useState('');

  const [newReferral, setNewReferral] = useState('0');
  const [sumCareRec, setSumCareRec] = useState('');
  const [refProvider, setRefProvider] = useState('');
  const [reason, setReason] = useState('');
  const navigate = useNavigate();

  const [checkAppExist, setCheckAppExist] = useState(false);
  const [checkAppBodyText, setCheckAppBodyText] = useState(false);
  const [editGroupAppId, setEditGroupAppId] = useState(0);
  const [editFlag, setEditFlag] = useState(false);
  const [alertPopup, setAlertPopup] = useState(false);
  const [confirmBlockedApp, setConfirmBlockedApp] = useState({
    status: false,
    data: '',
    type: '',
  });
  const durationRef = useRef(null);
  const [intakeForms, setIntakeForms] = useState('0');
  const [checkedIds, setCheckedIds] = useState([]);
  const [reopenFlag, setReopenFlag] = useState(false);
  // const [intakeFromPreviewPopup, setIntakeFromPreviewPopup] = useState(false);
  // const [docsUri, setDocsUri] = useState('');
  const [alertDialoguePopup, setAlertDialoguePopup] = useState(false);
  const [alertDialogueMsg, setAlertDialogueMsg] = useState('');
  const [mode, setMode] = useState(0);
  const [providerScheduleEnd, setProviderScheduleEnd] = useState(null);
  const [overrideSetting, setOverrideSetting] = useState([]);
  const [openMyCalander, setOpenMyCalander] = useState([]);
  const [warnigImg, setWarnigImg] = useState({
    status: false,
    img: '',
  });
  const [originalAppDate, setOriginalAppDate] = useState(null);

  useEffect(() => {
    if (globalAppId) {
      setEditFlag(true);
      if (appReschedule.status) {
        setEditFlag(false);
      }
      if (bookNewApp.status) {
        setEditFlag(false);
      }
    }
  }, [globalAppId, appReschedule.status, bookNewApp.status]);

  useEffect(() => {
    (async () => {
      try {
        const response = await post(
          'api/appointment/appointment/showAppointmentFormPopup',
          {
            appointmentId: globalAppId || '',
            callForEditApp: '0',
            callForReschedule: '0',
            patientId: '',
            encounterOnly: '',
            loginUserId: user?.id,
          },
        );

        if (response.status === 200) {
          setAllDetaSet(response?.data);
          setAllResource(response?.data?.allResource);
          setAllProvider(response?.data?.allProvider);
          setAllLocation(response?.data?.allLocation);
          setTypeOfVisitList(response?.data?.allTypeOfVisit);
          setAllTypeOfPayment(response?.data?.allTypeOfPayment);
          // dispatch(
          //   setAppPopupFacility(
          //     response?.data?.clinicData.reduce((acc, option) => {
          //       acc[option.location_code] = option.id; // Initialize all checkboxes as checked
          //       return acc;
          //     }, {})
          //   )
          // );
          // dispatch(
          //   setAppPopupFacility(parseInt(response?.data?.defaultLocation)),
          // );

          if (!globalAppId) {
            setLocation(response?.data?.defaultLocation);

            setResource(response?.data?.defaultResource);
            setProvider(response?.data?.defaultProvider);

            setAppColor(response?.data?.defaultScheduleColor);

            setTypeOfVisit(response?.data?.defaultTov);

            setDuration(
              response?.data?.defaultDuration
                ? response?.data?.defaultDuration
                : 2,
            );

            setTypeOfPayment(response?.data?.defaultPaymentType);
          } else {
            const editAppInfo = response?.data?.editInfo?.editAppInfo;
            setEditGroupAppId(editAppInfo?.groupAppId || 0);

            dispatch(setGrpAppPatsNull([]));
            setTelemedicine(editAppInfo?.telemedicine);
            setResource(parseInt(editAppInfo?.resource_id));
            setProvider(parseInt(editAppInfo?.provider_id));

            setLocation(editAppInfo?.clinic_id);

            setAppColor(editAppInfo?.app_sch_color);

            setTypeOfVisit(editAppInfo?.type_of_visit);

            setDuration(editAppInfo?.duration_id);

            setTypeOfPayment(editAppInfo?.payment_type);
            if (bookNewApp.status) {
              setAppDate(new Date());
              setOriginalAppDate(new Date());
              setAppTime(null);
            } else {
              setAppDate(new Date(editAppInfo?.start_app_date));
              setOriginalAppDate(new Date(editAppInfo?.start_app_date));
              setAppTime(
                getValidTime(
                  new Date(editAppInfo?.start_app_date),
                  editAppInfo?.startTime,
                ) ?? null,
              );
            }
            setPcp(editAppInfo?.pcp);
            setNewReferral(editAppInfo?.referral_flag);
            setSumCareRec(editAppInfo?.toc_type);
            setReason(editAppInfo?.visit_note);
            setRefProvider(editAppInfo?.ref_provider);
            if (
              response?.data?.selFormArr &&
              response?.data?.selFormArr.length > 0
            ) {
              setCheckedIds(response?.data?.selFormArr);
              setIntakeForms('1');
              setReopenFlag('0');
            }
            if (parseInt(editAppInfo?.referral_flag) === 1) {
              setEnableScr(true);
            } else {
              setEnableScr(false);
            }
            if (parseInt(editAppInfo?.groupAppId)) {
              setSelPatName('');
              setSelPatForApp('');
              const grpPatStr = editAppInfo?.patientDetail?.split('===');
              grpPatStr.forEach((data) => {
                if (data) {
                  let child = data?.split('|');
                  dispatch(
                    setGrpAppPats({
                      userId: child[1],
                      getPatientType: child[2],
                      getNewPatientType: child[3],
                      patName: child[0],
                      chart_number: child[5],
                      lastVisDt: child[7] || '',
                      lastVisTov: child[8] || '',
                      lastAppResName: child[6] || '',
                    }),
                  );
                }
              });
              dispatch(setGrpApp(true));
              if (editAppInfo?.getArrivedPat) {
                const arivedPatients = editAppInfo?.getArrivedPat.split(',');
                dispatch(setGrpAppArivedPats(arivedPatients));
              }
            } else {
              setSelPatName(editAppInfo?.patient_name);
              setSelPatForApp(parseInt(editAppInfo?.patId));
              dispatch(setGrpApp(false));
            }
          }
        }
      } catch (err) {
        setUiMessage('err', err.message);
      }
    })();
  }, [globalAppId, dispatch, bookNewApp, user?.id]);

  useEffect(() => {
    if (selectedSerchPat) {
      setSelPatForApp(selectedSerchPat?.patId);
      setSelPatType(selectedSerchPat?.getPatientType);
      setSelPatName(selectedSerchPat?.patName);
      setSelNewPatType(selectedSerchPat?.selNewPatType);
      if (selectedSerchPat?.appDate) {
        setAppDate(new Date(selectedSerchPat?.appDate));
        setAppTime(new Date(selectedSerchPat?.appDate));
      }
    }
  }, [selectedSerchPat]);

  useEffect(() => {
    if (
      patAlertData?.alertActive?.active_alert_notification === '1' &&
      patAlertData?.patientId === selPatForApp
    ) {
      setAlertPopup((prev) => true);
    } else {
      if (selPatForApp) {
        const fetchAlert = async () => {
          try {
            const response = await post(
              'api/patient/ProgressNote/openSpecificAlert',
              {
                patientId: selPatForApp,
              },
            );
            if (response.status === 200) {
              dispatch(setPatAlertData(response.data));
            }
          } catch (err) {
            setUiMessage('err', err.message);
          }
        };
        fetchAlert();
      }
    }
  }, [
    patAlertData?.alertActive?.active_alert_notification,
    patAlertData?.patientId,
    selPatForApp,
    dispatch,
  ]);

  useEffect(() => {
    if (
      Date.parse(format(new Date(appDate), DEFAULT_DATE_FORMATE)) >=
      Date.parse(format(new Date(), DEFAULT_DATE_FORMATE))
    ) {
      setEditFlag(false);
    }
  }, [appDate]);

  useEffect(() => {
    setGrpAppOnAppPopup(grpApp);
    setGrpAppChkBox(grpApp);

    if (!grpApp) {
      dispatch(setGrpAppPatsNull([]));
    } else {
      dispatch(setSeltSerchPat({}));
      setSelPatName('');
    }
  }, [grpApp, dispatch]);

  useEffect(() => {
    if (location) {
      const handleLocationData = async (locId, globalAppId = '') => {
        try {
          const response = await post(
            'api/appointment/appointment/getLocationDataByLocationId',
            {
              locationId: locId,
              loginUserId: globalAppId ? String(resource) : user?.id,
            },
          );

          if (response.status === 200) {
            setAllLocDataSet(response?.data);
            const locPro = response?.data?.allRes?.filter(
              (data) => data.id === response?.data?.defaultRes,
            );

            if (locPro) {
              setTypeOfVisitList(locPro[0]?.tovList);
              setProviderScheduleEnd(locPro[0]?.providerScheduleEnd);
              setOverrideSetting(locPro[0]?.overrideSetting || []);
              setOpenMyCalander(locPro[0]?.openMyCalander || []);
            } else {
              setTypeOfVisitList([]);
              setProviderScheduleEnd(null);
              setOverrideSetting([]);
              setOpenMyCalander([]);
            }
            if (globalAppId) {
              setAllResource(response?.data?.allRes);
              setAllProvider(response?.data?.allPro);
            } else {
              setAllResource(response?.data?.allRes);
              setResource(response?.data?.defaultRes);

              setAllProvider(response?.data?.allPro);
              setProvider(response?.data?.defaultPro);
            }
          }
        } catch (err) {
          setUiMessage('err', err.message);
        }
      };

      handleLocationData(location, globalAppId);
    } else {
      setTypeOfVisitList([]);
      setAllResource([]);
      setAllProvider([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location, globalAppId, user?.id]);

  useEffect(() => {
    if (appDate && allDataSet?.providerTiming && location && resource) {
      const providerHourInfo = allDataSet?.providerTiming[resource];
      const dayId = getDay(appDate);

      const providerTimes =
        providerHourInfo[
          (parseInt(dayId) === 0 ? 7 + '_' + location : parseInt(dayId)) +
            '_' +
            location
        ];

      if (providerTimes?.is_closed === 0) {
        setAppMinTime(new Date().setHours(24));
        setAppMaxTime(new Date().setHours(0));
      } else {
        const minTime = getValidTime(appDate, providerTimes?.open_time);
        const maxTime = getValidTime(appDate, providerTimes?.close_time);

        const fbs = providerTimes?.break_first_start_time;
        const fbe = providerTimes?.break_first_end_time;
        let breakArr = [];
        if (fbs && fbe && getTimeInIntervel(appDate, fbs, fbe)) {
          breakArr.push(...getTimeInIntervel(appDate, fbs, fbe));
        }

        const sbs = providerTimes?.break_second_start_time;
        const sbe = providerTimes?.break_second_end_time;
        if (sbs && sbe && getTimeInIntervel(appDate, sbs, sbe)) {
          breakArr.push(...getTimeInIntervel(appDate, sbs, sbe));
        }

        setAppMinTime(minTime);
        setAppMaxTime(maxTime);
        setProvidersBreak(breakArr);
      }
    }
  }, [allDataSet, location, appDate, resource]);

  const handleRecurErrors = (recurranceFormData) => {
    let flag = false;
    if (recurranceFormData.occur_type === '0') {
      if (recurranceFormData?.recur_value === '') {
        setUiMessage('err', 'Select recur every week(s) on');
        flag = true;
      }
      if (
        recurranceFormData?.chckMon === 0 &&
        recurranceFormData?.chckTue === 0 &&
        recurranceFormData?.chckWed === 0 &&
        recurranceFormData?.chckThu === 0 &&
        recurranceFormData?.chckFri === 0 &&
        recurranceFormData?.chckSat === 0 &&
        recurranceFormData?.chckSun === 0
      ) {
        setUiMessage('err', 'Select any week day for processing.');
        flag = true;
      }
      if (recurranceFormData?.occur_end_after === '') {
        setUiMessage('err', 'Select end after occurrences.');
        flag = true;
      }
    }
    if (recurranceFormData.occur_type === '1') {
      if (recurranceFormData?.sub_occur_type === '0') {
        if (recurranceFormData?.monthly_day === '') {
          setUiMessage('err', 'Select days of.');
          flag = true;
        }
        if (recurranceFormData?.recur_value === '') {
          setUiMessage('err', 'Select months(s).');
          flag = true;
        }
      } else {
        if (recurranceFormData?.week_day === '') {
          setUiMessage('err', 'Select value from dropdown');
          flag = true;
        }
        if (recurranceFormData?.monthly_day === '') {
          setUiMessage('err', 'Select day from dropdown');
          flag = true;
        }
      }
      if (recurranceFormData?.occur_end_after === '') {
        setUiMessage('err', 'Select end after occurrences.');
        flag = true;
      }
    }
    if (recurranceFormData.occur_type === '2') {
      if (recurranceFormData?.recur_value === '') {
        setUiMessage('err', 'Select recur every week(s) on.');
        flag = true;
      }

      if (recurranceFormData?.sub_occur_type === '0') {
        if (recurranceFormData?.yearly_day === '') {
          setUiMessage('err', 'Select on field from recurrence.');
          flag = true;
        }
        if (recurranceFormData?.yearly_month === '') {
          setUiMessage('err', 'Select on field from recurrence.');
          flag = true;
        }
      } else {
        if (recurranceFormData?.week_day === '') {
          setUiMessage('err', 'Select on the field from recurrence.');
          flag = true;
        }
        if (recurranceFormData?.yearly_day === '') {
          setUiMessage('err', 'Select on the second field from recurrence.');
          flag = true;
        }
        if (recurranceFormData?.yearly_month === '') {
          setUiMessage('err', 'Select on the last field from recurrence.');
          flag = true;
        }
      }

      if (recurranceFormData?.occur_end_after === '') {
        setUiMessage('err', 'Select end after occurrences.');
        flag = true;
      }
    }
    return flag;
  };

  const checkProviderClosedDayAppForm = (dataArr, res, locs) => {
    if (res && locs) {
      const providerHourInfo = dataArr?.providerTiming[res];
      let a = [];
      for (let ab in providerHourInfo) {
        let dayIdClinicId = ab.split('_');
        let dayId = dayIdClinicId[0];
        let clinicId = dayIdClinicId[1];
        if (locs === clinicId) {
          let allDayInfo = providerHourInfo[ab];
          let is_closed = parseInt(allDayInfo.is_closed);
          dayId = dayId === '7' ? 0 : dayId;
          if (is_closed === 0) {
            a.push(parseInt(dayId));
          }
        }
      }
      setCloseDay(a);
    }
  };

  const providerHolidayList = (dataArr, res) => {
    let finalArr = [];
    const hyDy = dataArr?.providerHolidayList.filter(
      (data) => data.providerId === res,
    );
    for (let i in hyDy) {
      finalArr.push(new Date(hyDy[i]?.holidayDate));
    }
    setHolidayList(finalArr);
  };

  const highlightWithRanges = useMemo(
    () => [{ 'react-datepicker__day--highlighted-custom-2': holidayList }],
    [holidayList],
  );

  function openDatePicker() {
    const isExistingApp = globalAppId && !bookNewApp?.status;
    const isOriginalPast = originalAppDate && isBefore(
      new Date(originalAppDate).setHours(0, 0, 0, 0),
      new Date().setHours(0, 0, 0, 0),
    );

    if (isExistingApp && isOriginalPast) return;
    setAppDatePickerIsOpen(!appDatePickerIsOpen);
    checkProviderClosedDayAppForm(allDataSet, resource, location);
    providerHolidayList(allDataSet, resource);
  }

  function openTimePicker() {
    //if (editFlag) return;
    setAppTimePickerIsOpen(!appTimePickerIsOpen);
  }

  function handleDateSelect(dateEvent) {
    setAppDatePickerIsOpen(!appDatePickerIsOpen);
    setTimeSlotPopup(true);
  }

  function handlTimeSelect(dateEvent) {
    if (!appDate) {
      setUiMessage('war', 'Please select appontment date first.');
    } else {
      setAppTime(dateEvent);
      setAppTimePickerIsOpen(!appTimePickerIsOpen);
      setTimeSlotPopup(false);
    }
  }
  //handle recurrance appointment
  const handleRecurrence = (e) => {
    const { checked } = e.target;
    setRecurrencePopup(checked);
    setRecurrence(checked);

    // const wrapper = document.querySelector('.recurrence-popup-wrapper');
    // wrapper?.classList?.toggle('show');
  };

  useEffect(() => {
    if (recurPopupSataus?.status && recurPopupSataus?.type === '1') {
      setRecurrencePopup(true);
      setRecurrence(recurPopupSataus?.type);
    }
  }, [recurPopupSataus]);

  //set app color from color pallet
  const pickScheduleColor = (color) => {
    setAppColor(color);
    setColorPalette(false);
  };

  const handleLocationChange = async (e) => {
    const locId = e.target.value;
    setLocation(locId);
    // handleLocationData(locId);
    setMode(0);
  };

  const handleResourceChange = (resId, globalAppId) => {
    //const resId = e.target.value;
    if (resId) {
      setResource(resId);
      const locPro = allLocDataSet?.allRes?.filter((data) => data.id === resId);
      if (locPro) {
        setTypeOfVisitList(locPro[0]?.tovList);
        setProviderScheduleEnd(locPro[0]?.providerScheduleEnd);
        setOverrideSetting(locPro[0]?.overrideSetting || []);
        setOpenMyCalander(locPro[0]?.openMyCalander || []);
        if (globalAppId) {
          setTypeOfVisit(locPro[0]?.defTov ? locPro[0]?.defTov : typeOfVisit);
        } else {
          setTypeOfVisit(locPro[0]?.defTov || '');
        }

        setDuration(locPro[0]?.defDuration || 2);
        setAppColor(locPro[0]?.defScheduleColor || '');
        setTypeOfPayment(locPro[0]?.defPayType || '');
        checkProviderClosedDayAppForm(allDataSet, resId, location);
        const isProIdPresent = allProvider.some(
          (pro) => pro.id === locPro[0]?.defaultProvider,
        );
        setProvider(isProIdPresent ? locPro[0]?.defaultProvider : '');
      }
    } else {
      setResource('');
      setDuration(2);
      setAppColor('unset');
      setTypeOfPayment('');
      setTypeOfVisit('');
      setProvider('');
      setProviderScheduleEnd(null);
      setOverrideSetting([]);
      setOpenMyCalander([]);
    }
  };

  const handleTypeOfVisit = (e) => {
    const tov = e.target.value;
    setTypeOfVisit(tov);
    const locPro = allLocDataSet?.allRes?.filter(
      (data) => data.id === resource,
    );
    if (locPro && locPro.length > 0) {
      const tovData = locPro[0]?.tovList?.filter((data) => data.id === tov);
      setDuration(tovData[0]?.defDuration);
      setAppColor(tovData[0]?.defScheduleColor);
    }
  };

  const handleSuggestTime = async () => {
    try {
      if (appDate) {
        // let selDurArr = allDataSet?.allDuration.filter(
        //   (i) => parseInt(i.id) === duration
        // );
        // let selDur = selDurArr[0];
        const response = await post('api/appointment/appointment/suggestTime', {
          providerId: resource,
          currentSelectedTime: appTime ? format(appTime, 'HH:mm a') : '',
          currentSelectedDate: format(appDate, 'MM-dd-yyyy'),
          duration: durationText,
          locationId: location,
        });

        if (response.status === 200) {
          if (parseInt(response?.data?.time) === 3) {
            setWarnigImg({ status: true, img: '⚠️' });
            setUiMessage('err', 'Provider has closed the day.');
          } else if (parseInt(response?.data?.time) === 2) {
            setWarnigImg({ status: true, img: '⚠️' });
            setUiMessage('err', 'No time slot available for this provider.');
          } else if (parseInt(response?.data?.time) === 0) {
            setWarnigImg({ status: true, img: '⚠️' });
            setUiMessage('err', 'Time slot not available.');
          } else if (parseInt(response?.data?.time) === 4) {
            setWarnigImg({ status: true, img: '⚠️' });
            setUiMessage('war', 'Provider is not available on selected date.');
          } else {
            setAppTime(new Date(response?.data?.time));
            setWarnigImg({ status: false, img: '✔' });
          }
        }
        if (timeSlotPopup) {
          setTimeSlotPopup(false);
        }
      } else {
        setUiMessage('war', 'Please select appointment date first.');
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };
  const handleTimeslotPopup = () => {
    if (appDate) {
      setTimeSlotPopup(true);
    } else {
      setUiMessage('war', 'Please select appointment date first.');
    }
    if (timeSlotPopup) {
      setTimeSlotPopup(false);
    }
  };

  const addThisTimeSlot = (time) => {
    let hours = parseInt(time.split(':')[0], 10);
    let minutes = parseInt(time.split(':')[1].split(' ')[0], 10);

    let period = time.split(' ')[1];
    if (period === 'PM' && hours < 12) {
      hours += 12;
    }
    let t = new Date();
    t.setHours(hours);
    t.setMinutes(minutes);
    setAppTime(t);
    setTimeSlotPopup(false);
  };

  const handleNewReferral = (e) => {
    const { checked } = e.target;
    // console.dir(e.target);
    if (checked) {
      setEnableScr(true);
      setNewReferral('1');
    } else {
      setEnableScr(false);
      setSumCareRec('');
      setRefProvider('');
      setNewReferral('0');
    }
  };

  const handleAppReschedule = async () => {
    try {
      if (selPatForApp && appDate) {
        const response = await post(
          'api/appointment/appointment/getAvailableDateForPatient',
          {
            patientId: selPatForApp,
            checkDate: appDate ? format(appDate, 'MM-dd-yyyy') : null,
            exAppId: '',
          },
        );
        if (response.status === 200) {
          if (response.data?.str) {
            setCheckAppBodyText(response?.data?.str);
            setCheckAppExist(true);
          } else {
            handleRescheduleConfirm();
          }
        }
      } else {
        setUiMessage('war', 'Please provide form data.');
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };

  const handleRescheduleConfirm = async () => {
    const prams = {
      loginUserId: user?.id,
      recordId: globalAppId, // app id when reschedule or edit
      provider: provider,
      app_date: appDate ? format(appDate, 'MM-dd-yyyy') : null,
      app_time: appTime ? format(appTime, 'hh:mm a') : null,
      patient: selPatForApp,
      type_of_visit: typeOfVisit,
      duration: durationText,
      duration_id: duration,
      payment_type: typeOfPayment,
      patientId: selPatForApp,
      reason: reason,
      primaryCarePhy: pcp,
      newReferralFlag: newReferral,
      tocType: sumCareRec, //summary care recived
      resourceId: resource,
      approvalReq: 0,
      patientType: selPatType,
      newPatientType: selNewPatType,
      refProvider: refProvider,
      appmtOption: recurrence ? 1 : 0,
      selPatId: '',
      locationId: location,
      encounterOnly: '', ///blank
      appSchedulerColor: appColor,
      labApp: '', ///blank
      groupApp: grpApp ? 1 : 0,
      groupAppId: 0,
      telemedicine: telemedicine,
      selFormId: intakeForms === '1' ? checkedIds.join(',') : '',
    };

    let patIdsArr = [];
    let patIdsStrArr = {};
    for (let i in grpAppPats) {
      patIdsArr.push(grpAppPats[i].userId);
      patIdsStrArr['patientDetail' + grpAppPats[i].userId] =
        grpAppPats[i].userId +
        '|' +
        grpAppPats[i].getPatientType +
        '|' +
        grpAppPats[i].getNewPatientType;
    }
    patIdsStrArr['selPatId'] = patIdsArr.join(',');

    let pramsObj;
    if (recurrence) {
      pramsObj = Object.assign({}, prams, recurranceFormData);
    } else if (grpApp) {
      pramsObj = Object.assign({}, prams, patIdsStrArr);
    } else {
      pramsObj = prams;
    }

    try {
      if (!(selPatForApp || patIdsArr.length > 0)) {
        setUiMessage('err', 'Select patient');
      } else if (!location) {
        setUiMessage('err', 'Select appoinment location');
      } else if (!resource) {
        setUiMessage('err', 'Select appoinment resource');
      } else if (!provider) {
        setUiMessage('err', 'Select appoinment provider');
      } else if (!appDate) {
        setUiMessage('err', 'Select appoinment date');
      } else if (!appTime) {
        setUiMessage('err', 'Select appoinment time');
      } else if (
        !typeOfVisit ||
        parseInt(typeOfVisit) === 0 ||
        typeOfVisit === ''
      ) {
        setUiMessage('err', 'Select type of visit');
      } else if (!duration) {
        setUiMessage('err', 'Select appoinment duration');
      } else if (!typeOfPayment) {
        setUiMessage('err', 'Select payment type');
      } else if (recurrence && handleRecurErrors(recurranceFormData)) {
      } else if (
        appDate &&
        appTime &&
        (selPatForApp || grpApp) &&
        typeOfVisit
      ) {
        const response = await post(
          'api/appointment/appointment/saveAppointment',
          pramsObj,
        );
        if (response.status === 200) {
          if (parseInt(response?.data?.successCode) === 1) {
            setUiMessage('suc', response?.data?.errorMsg);
          } else if (parseInt(response?.data?.successCode) === 0) {
            if (response?.data?.blockStatus === '1') {
              setConfirmBlockedApp((preVal) => {
                return {
                  ...preVal,
                  status: true,
                  data: 'blockTimeByPass',
                  type: 'save',
                };
              });
            } else {
              setUiMessage('err', response?.data?.errorMsg);
            }
          } else {
            setUiMessage('war', response?.data?.errorMsg);
          }
          changeRescheduleStatus([response.data?.appointmentId]);
          handleClose();
        }
      } else {
        setUiMessage('war', 'Please provide form data.');
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };

  const changeRescheduleStatus = async (params) => {
    try {
      const response = await post(
        'api/appointment/Appointment/changeCurrentStatus',
        {
          appointmentId: globalAppId,
          currentStatusId: 3,
          currentStatusAutoIncId: appReschedule.appStatusAutoId,
          loginUserId: user?.id,
          reason: appReschedule.text,
          rescheduleAppId: params[0],
          is_no_show_billed: appReschedule.is_no_show_billed,
        },
      );
      if (response?.status === 200) {
        setUiMessage('suc', 'Appointment reschedule successfully.');
        dispatch(handleGlobalReload(!globalReload));
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };

  const handleAppSave = async () => {
    try {
      if (!selPatForApp && !grpApp) {
        setUiMessage('err', 'Select patient');
      } else if (!location) {
        setUiMessage('err', 'Select appoinment location');
      } else if (!resource) {
        setUiMessage('err', 'Select appoinment resource');
      } else if (!provider) {
        setUiMessage('err', 'Select appoinment provider');
      } else if (!appDate) {
        setUiMessage('err', 'Select appoinment date');
      } else if (!appTime) {
        setUiMessage('err', 'Select appoinment time');
      } else if (
        !typeOfVisit ||
        parseInt(typeOfVisit) === 0 ||
        typeOfVisit === ''
      ) {
        setUiMessage('err', 'Select type of visit');
      } else if (!duration) {
        setUiMessage('err', 'Select appoinment duration');
      } else if (!typeOfPayment) {
        setUiMessage('err', 'Select payment type');
      } else if (appDate && appTime && selPatForApp && typeOfVisit) {
        const response = await post(
          'api/appointment/appointment/getAvailableDateForPatient',
          {
            patientId: selPatForApp,
            checkDate: appDate ? format(appDate, 'MM-dd-yyyy') : null,
            exAppId: '',
          },
        );
        if (response.status === 200) {
          if (response.data?.str) {
            setCheckAppBodyText(response?.data?.str);
            setCheckAppExist(true);
          } else {
            handleAppSaveConfirm();
          }
        }
      } else {
        //setUiMessage('war', 'Please provide form data.');
        handleAppSaveConfirm();
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };
  const handleAppSaveConfirm = async () => {
    const prams = {
      loginUserId: user?.id,
      recordId: 0, // app id when reschedule or edit
      provider: provider,
      app_date: appDate ? format(appDate, 'MM-dd-yyyy') : null,
      app_time: appTime ? format(appTime, 'hh:mm a') : null,
      patient: selPatForApp,
      type_of_visit: typeOfVisit,
      duration: durationText,
      duration_id: duration,
      payment_type: typeOfPayment,
      patientId: selPatForApp,
      reason: reason,
      primaryCarePhy: pcp,
      newReferralFlag: newReferral,
      tocType: sumCareRec, //summary care recived
      resourceId: resource,
      approvalReq: 0,
      patientType: selPatType,
      newPatientType: selNewPatType,
      refProvider: refProvider,
      appmtOption: recurrence ? 1 : 0,
      selPatId: '',
      locationId: location,
      encounterOnly: '', ///blank
      appSchedulerColor: appColor,
      labApp: '', ///blank
      groupApp: grpApp ? 1 : 0,
      telemedicine: telemedicine,
      selFormId: intakeForms === '1' ? checkedIds.join(',') : '',
    };

    if (confirmBlockedApp.status) {
      prams['blockTimeByPass'] = 'blockTimeByPass';
    }

    let patIdsArr = [];
    let patIdsStrArr = {};
    for (let i in grpAppPats) {
      patIdsArr.push(grpAppPats[i].userId);
      patIdsStrArr['patientDetail' + grpAppPats[i].userId] =
        grpAppPats[i].userId +
        '|' +
        grpAppPats[i].getPatientType +
        '|' +
        grpAppPats[i].getNewPatientType;
    }
    patIdsStrArr['selPatId'] = patIdsArr.join(',');

    let pramsObj;
    if (recurrence) {
      pramsObj = Object.assign({}, prams, recurranceFormData);
    } else if (grpApp) {
      pramsObj = Object.assign({}, prams, patIdsStrArr);
    } else {
      pramsObj = prams;
    }

    try {
      if (!(selPatForApp || patIdsArr.length > 0)) {
        setUiMessage('err', 'Select patient');
      } else if (!location) {
        setUiMessage('err', 'Select appoinment location');
      } else if (!resource) {
        setUiMessage('err', 'Select appoinment resource');
      } else if (!provider) {
        setUiMessage('err', 'Select appoinment provider');
      } else if (!appDate) {
        setUiMessage('err', 'Select appoinment date');
      } else if (!appTime) {
        setUiMessage('err', 'Select appoinment time');
      } else if (
        !typeOfVisit ||
        parseInt(typeOfVisit) === 0 ||
        typeOfVisit === ''
      ) {
        setUiMessage('err', 'Select type of visit');
      } else if (!duration) {
        setUiMessage('err', 'Select appoinment duration');
      } else if (!typeOfPayment) {
        setUiMessage('err', 'Select payment type');
      } else if (recurrence && handleRecurErrors(recurranceFormData)) {
      } else if (
        appDate &&
        appTime &&
        (selPatForApp || grpApp) &&
        typeOfVisit
      ) {
        const response = await post(
          'api/appointment/appointment/saveAppointment',
          pramsObj,
        );
        if (response.status === 200) {
          if (parseInt(response?.data?.successCode) === 1) {
            if (isCheckoutProcess?.status) {
              const statusRes = await handleAppStatus(
                isCheckoutProcess?.appid,
                7,
                isCheckoutProcess?.curStatAutoIncId,
                selPatForApp,
                user?.id,
              );

              if (statusRes?.status === 200) {
                if (statusRes?.data?.successCode === 1) {
                  setUiMessage(
                    'suc',
                    'Appointment status change successfully.',
                  );
                } else {
                  setUiMessage('inf', 'Unable to change appointment status.');
                }
                dispatch(handleGlobalReload(!globalReload));
              }
            } else {
              dispatch(handleGlobalReload(!globalReload));
            }
            setUiMessage('suc', response?.data?.errorMsg);
            handleClose();
          } else if (parseInt(response?.data?.successCode) === 0) {
            if (response?.data?.blockStatus === '1') {
              setConfirmBlockedApp((preVal) => {
                return {
                  ...preVal,
                  status: true,
                  data: 'blockTimeByPass',
                  type: 'save',
                };
              });
            } else {
              setUiMessage('err', response?.data?.errorMsg);
            }
          } else {
            setUiMessage('war', response?.data?.errorMsg);
          }
          //handleGoToAppList();
        }
      } else {
        setUiMessage('war', 'Please provide form data.');
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };

  const handleRecurAppUpdate = async () => {
    try {
      if (!location) {
        setUiMessage('err', 'Select appoinment location');
      } else if (!resource) {
        setUiMessage('err', 'Select appoinment resource');
      } else if (!provider) {
        setUiMessage('err', 'Select appoinment provider');
      } else if (!appDate) {
        setUiMessage('err', 'Select appoinment date');
      } else if (!appTime) {
        setUiMessage('err', 'Select appoinment time');
      } else if (
        !typeOfVisit ||
        parseInt(typeOfVisit) === 0 ||
        typeOfVisit === ''
      ) {
        setUiMessage('err', 'Select type of visit');
      } else if (!duration) {
        setUiMessage('err', 'Select appoinment duration');
      } else if (!typeOfPayment) {
        setUiMessage('err', 'Select payment type');
      } else if (recurrence && handleRecurErrors(recurranceFormData)) {
      } else if (
        appDate &&
        appTime &&
        selPatForApp &&
        typeOfVisit &&
        !recurrence
      ) {
        const response = await post(
          'api/appointment/appointment/getAvailableDateForPatient',
          {
            patientId: selPatForApp,
            checkDate: appDate ? format(appDate, 'MM-dd-yyyy') : null,
            exAppId: '',
          },
        );
        if (response.status === 200) {
          if (response.data?.str) {
            setCheckAppBodyText(response?.data?.str);
            setCheckAppExist(true);
          } else {
            handleRecurAppUpdateConfirm();
          }
        }
      } else {
        //setUiMessage('war', 'Please provide form data.');
        handleRecurAppUpdateConfirm();
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };
  const handleRecurAppUpdateConfirm = async () => {
    const prams = {
      loginUserId: user?.id,
      recordId: globalAppId, // app id when reschedule or edit
      provider: provider,
      app_date: appDate ? format(appDate, 'MM-dd-yyyy') : null,
      app_time: appTime ? format(appTime, 'hh:mm a') : null,
      patient: selPatForApp,
      type_of_visit: typeOfVisit,
      duration: durationText,
      duration_id: duration,
      payment_type: typeOfPayment,
      patientId: selPatForApp,
      reason: reason,
      primaryCarePhy: pcp,
      newReferralFlag: newReferral,
      tocType: sumCareRec, //summary care recived
      resourceId: resource,
      approvalReq: 0,
      patientType: selPatType,
      newPatientType: selNewPatType,
      refProvider: refProvider,
      appmtOption: recurrence ? 1 : 0,
      selPatId: '',
      locationId: location,
      encounterOnly: '', ///blank
      appSchedulerColor: appColor,
      labApp: '', ///blank
      groupApp: grpApp ? 1 : 0,
      telemedicine: telemedicine,
      recurringId: recurPopupSataus?.recurringId,
      selFormId: intakeForms === '1' ? checkedIds.join(',') : '',
    };

    if (confirmBlockedApp.status) {
      prams['blockTimeByPass'] = 'blockTimeByPass';
    }

    let patIdsArr = [];
    let patIdsStrArr = {};
    for (let i in grpAppPats) {
      patIdsArr.push(grpAppPats[i].userId);
      patIdsStrArr['patientDetail' + grpAppPats[i].userId] =
        grpAppPats[i].userId +
        '|' +
        grpAppPats[i].getPatientType +
        '|' +
        grpAppPats[i].getNewPatientType;
    }
    patIdsStrArr['selPatId'] = patIdsArr.join(',');

    let pramsObj;
    if (recurrence) {
      pramsObj = Object.assign({}, prams, recurranceFormData);
    } else if (grpApp) {
      pramsObj = Object.assign({}, prams, patIdsStrArr);
    } else {
      pramsObj = prams;
    }

    try {
      if (!(selPatForApp || patIdsArr.length > 0)) {
        setUiMessage('err', 'Select patient');
      } else if (
        appDate &&
        appTime &&
        (selPatForApp || grpApp) &&
        typeOfVisit
      ) {
        const response = await post(
          'api/appointment/appointment/saveAppointment',
          pramsObj,
        );
        if (response.status === 200) {
          if (parseInt(response?.data?.successCode) === 1) {
            setUiMessage('suc', response?.data?.errorMsg);
            handleClose();
            dispatch(handleGlobalReload(!globalReload));
          } else if (parseInt(response?.data?.successCode) === 0) {
            if (response?.data?.blockStatus === '1') {
              setConfirmBlockedApp((preVal) => {
                return {
                  ...preVal,
                  status: true,
                  data: 'blockTimeByPass',
                  type: 'save',
                };
              });
            } else {
              setUiMessage('err', response?.data?.errorMsg);
            }
          } else {
            setUiMessage('war', response?.data?.errorMsg);
          }
          //handleGoToAppList();
        }
      } else {
        setUiMessage('war', 'Please provide form data.');
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };

  const handleAppUpdate = async () => {
    const prams = {
      loginUserId: user?.id,
      recordId: globalAppId, // app id when reschedule or edit
      provider: provider,
      app_date: appDate ? format(appDate, 'MM-dd-yyyy') : null,
      app_time: appTime ? format(appTime, 'hh:mm a') : null,
      patient: selPatForApp,
      type_of_visit: typeOfVisit,
      duration: durationText,
      duration_id: duration,
      payment_type: typeOfPayment,
      patientId: selPatForApp,
      reason: reason,
      primaryCarePhy: pcp,
      newReferralFlag: newReferral,
      tocType: sumCareRec, //summary care recived
      resourceId: resource,
      approvalReq: 0,
      patientType: selPatType,
      newPatientType: selNewPatType,
      refProvider: refProvider,
      appmtOption: recurrence ? 1 : 0,
      selPatId: '',
      locationId: location,
      encounterOnly: '', ///blank
      appSchedulerColor: appColor,
      labApp: '', ///blank
      groupApp: grpApp ? 1 : 0,
      groupAppId: editGroupAppId,
      telemedicine: telemedicine,
      recurringId: recurPopupSataus?.recurringId,
      selFormId: intakeForms === '1' ? checkedIds.join(',') : '',
    };

    if (confirmBlockedApp.status) {
      prams['blockTimeByPass'] = 'blockTimeByPass';
    }

    let patIdsArr = [];
    let patIdsStrArr = {};
    for (let i in grpAppPats) {
      patIdsArr.push(grpAppPats[i].userId);
      patIdsStrArr['patientDetail' + grpAppPats[i].userId] =
        grpAppPats[i].userId +
        '|' +
        grpAppPats[i].getPatientType +
        '|' +
        grpAppPats[i].getNewPatientType;
    }
    patIdsStrArr['selPatId'] = patIdsArr.join(',');

    let pramsObj;
    if (recurrence) {
      pramsObj = Object.assign({}, prams, recurranceFormData);
    } else if (grpApp) {
      pramsObj = Object.assign({}, prams, patIdsStrArr);
    } else {
      pramsObj = prams;
    }

    try {
      if (!(selPatForApp || patIdsArr.length > 0)) {
        setUiMessage('err', 'Select patient');
      } else if (!location) {
        setUiMessage('err', 'Select appoinment location');
      } else if (!resource) {
        setUiMessage('err', 'Select appoinment resource');
      } else if (!provider) {
        setUiMessage('err', 'Select appoinment provider');
      } else if (!appDate) {
        setUiMessage('err', 'Select appoinment date');
      } else if (!appTime) {
        setUiMessage('err', 'Select appoinment time');
      } else if (
        !typeOfVisit ||
        parseInt(typeOfVisit) === 0 ||
        typeOfVisit === ''
      ) {
        setUiMessage('err', 'Select type of visit');
      } else if (!duration) {
        setUiMessage('err', 'Select appoinment duration');
      } else if (!typeOfPayment) {
        setUiMessage('err', 'Select payment type');
      } else if (recurrence && handleRecurErrors(recurranceFormData)) {
      } else if (
        appDate &&
        appTime &&
        (selPatForApp || grpApp) &&
        typeOfVisit
      ) {
        const response = await post(
          'api/appointment/appointment/updateAppointment',
          pramsObj,
        );
        if (response.status === 200) {
          if (parseInt(response?.data?.successCode) === 1) {
            setUiMessage('suc', response?.data?.errorMsg);
            if (isCheckoutProcess?.status) {
              const statusRes = await handleAppStatus(
                isCheckoutProcess?.appid,
                7,
                isCheckoutProcess?.curStatAutoIncId,
                selPatForApp,
                user?.id,
              );

              if (statusRes?.status === 200) {
                if (statusRes?.data?.successCode === 1) {
                  setUiMessage(
                    'suc',
                    'Appointment status change successfully.',
                  );
                } else {
                  setUiMessage('inf', 'Unable to change appointment status.');
                }
                dispatch(handleGlobalReload(!globalReload));
              }
            } else {
              dispatch(handleGlobalReload(!globalReload));
            }
            handleClose();
          } else if (parseInt(response?.data?.successCode) === 0) {
            if (response?.data?.blockStatus === '1') {
              setConfirmBlockedApp((preVal) => {
                return {
                  ...preVal,
                  status: true,
                  data: 'blockTimeByPass',
                  type: 'update',
                };
              });
            } else {
              setUiMessage('err', response?.data?.errorMsg);
            }
          } else {
            setUiMessage('err', 'Something went wrong.');
          }
          //handleGoToAppList();
        }
      } else {
        setUiMessage('war', 'Please provide form data.');
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };
  const handleGrpAppOnAppPopUp = (e) => {
    setGrpAppOnAppPopup(e.target.checked);
    setGrpAppChkBox(e.target.checked);
    dispatch(setGrpApp(e.target.checked));
    if (e.target.checked) {
      handleOpenPatSerch();
    }
  };

  const handleGrpAppClosed = () => {
    setGrpAppOnAppPopup(false);
  };

  const handleAppDate = (date) => {
    if (date) {
      setAppDate(date);
      if (!timeSlotPopup) {
        setTimeSlotPopup(true);
      }
    } else {
      setAppDate(null);
      setTimeSlotPopup(false);
    }
  };

  useEffect(() => {
    if (duration) {
      const selText =
        durationRef.current &&
        durationRef.current.options[
          durationRef.current.selectedIndex
        ].text.split(' ');
      setDurationText(selText[0]);
    }
  }, [duration]);

  const handleDuration = (e) => {
    const selText = e.target.options[e.target.selectedIndex].text.split(' ');
    setDuration(e.target.value);
    setDurationText(selText[0]);
  };

  const handleGoToAppList = () => {
    dispatch(defSchedTab('app'));
    navigate(`${DEFAULT_LOCAL_PATH}/scheduler/`);
    handleClose();
  };

  const handleRecurranceFormData = useCallback((data) => {
    setRecurranceFormData(data);
  }, []);

  useEffect(() => {
    (async () => {
      if (selPatForApp && typeOfVisit) {
        try {
          const response = await post(
            'api/patient/ManagePriorAuth/chkPriorAuthNotify',
            {
              patientId: selPatForApp,
              tov: typeOfVisit,
              resourceId: resource,
              appId: '',
              procedureId: '',
            },
          );
          if (response.status === 200) {
            if (response?.data?.alert === '1') {
              setAlertDialogueMsg(response?.data?.msg);
              setAlertDialoguePopup(true);
            }
          }
        } catch (error) {
          setUiMessage('err', error?.message);
        }
      }
    })();
  }, [selPatForApp, typeOfVisit, resource]);

  const filterDateForPicker = useMemo(() => {
    return (date) => {
      const dateStr = format(date, 'yyyy-MM-dd');
      const dayOfWeek = getDay(date) === 0 ? 7 : getDay(date);

      // 1. Highest Priority: "Open my calendar" tasks (Temporary Overrides)
      const openCal = Array.isArray(openMyCalander)
        ? openMyCalander
        : [openMyCalander].filter(Boolean);
      const overrides = Array.isArray(overrideSetting)
        ? overrideSetting
        : [overrideSetting].filter(Boolean);

      const hasOpenInterval =
        openCal.some((interval) => {
          if (!interval.start_time) return false;
          const intervalDateStr = interval.start_time.split(' ')[0];
          return intervalDateStr === dateStr;
        }) ||
        overrides.some((o) => {
          if (o?.start_time) {
            const intervalDateStr = o.start_time.split(' ')[0];
            return intervalDateStr === dateStr;
          }
          return false;
        });

      if (hasOpenInterval) return true;

      // 2. Next Priority: Full Weekly Override (Tab 3)
      const activeOverride = overrides.find((o) => {
        if (o?.schedule_type !== '1' || !o?.start_date || !o?.end_date)
          return false;

        // Use startOfDay comparison for clarity
        const d = new Date(date).setHours(0, 0, 0, 0);
        const s = new Date(o.start_date).setHours(0, 0, 0, 0);
        const e = new Date(o.end_date).setHours(0, 0, 0, 0);

        return d >= s && d <= e && parseInt(o.day_id) === dayOfWeek;
      });

      if (activeOverride) {
        return activeOverride.is_closed === '1'; // Enabled if is_closed is 1
      }

      // 3. Fallback to regular schedule
      if (providerScheduleEnd?.end_date) {
        const d = new Date(date).setHours(0, 0, 0, 0);
        const regularEnd = new Date(providerScheduleEnd.end_date).setHours(0, 0, 0, 0);
        if (d > regularEnd) {
          return false;
        }
      }

      return !closeDay.includes(getDay(date));
    };
  }, [openMyCalander, overrideSetting, closeDay, providerScheduleEnd]);

  const calculatedMaxDate = useMemo(() => {
    let max = providerScheduleEnd?.end_date
      ? new Date(providerScheduleEnd.end_date)
      : null;

    const overrides = Array.isArray(overrideSetting)
      ? overrideSetting
      : [overrideSetting].filter(Boolean);

    overrides.forEach((o) => {
      if (o?.end_date) {
        const oDate = new Date(o.end_date);
        if (!max || oDate > max) {
          max = oDate;
        }
      }
    });

    const openCal = Array.isArray(openMyCalander)
      ? openMyCalander
      : [openMyCalander].filter(Boolean);

    openCal.forEach((c) => {
      if (c?.start_time) {
        const cDate = new Date(c.start_time.split(' ')[0]);
        if (!max || cDate > max) {
          max = cDate;
        }
      }
    });

    return max;
  }, [providerScheduleEnd, overrideSetting, openMyCalander]);

  return (
    <div className="modalBackground">
      <div className="book-appt-contnr tab-bg">
        <div className="appt-hx-hdr-pt-info">
          <span className="rc-pt-nm">Book an appointment</span>
          <Button variant="circle" onClick={handleClose}>
            X
          </Button>
        </div>
        <div style={{ display: 'flex' }}>
          <div className="book-appt-body" style={{ width: '40%' }}>
            <div className="appt-hx-fa-rw">
              <span className="label">
                Patient:<span className="required-fld">*</span>
              </span>
              <span className="value">
                <input
                  type="search"
                  className="searchPatient"
                  placeholder="Search Patient..."
                  readOnly
                  onClick={patSrchDiasbled ? () => {} : handleOpenPatSerch}
                  value={selPatName || ''}
                />
              </span>
            </div>
            <div className="appt-hx-fa-rw">
              <div className="appt-check-sec" style={{ display: 'flex' }}>
                <span
                  className="book-appt-check"
                  style={{ marginRight: '10px' }}
                >
                  <input
                    type="checkbox"
                    value={telemedicine || '0'}
                    onChange={(e) =>
                      setTelemedicine(e.target.checked ? '1' : '0')
                    }
                    checked={telemedicine === '1' ? true : false}
                    //disabled={recurPopupSataus.status}
                  />
                  &nbsp;
                </span>
                <span className="book-appt-check-val">Telemedicine</span>
              </div>
              <div
                className="appt-check-sec"
                style={{ display: 'flex', position: 'relative' }}
              >
                <span
                  className="book-appt-check"
                  style={{ marginRight: '10px' }}
                >
                  <input
                    type="checkbox"
                    value={recurrence || '0'}
                    onChange={handleRecurrence}
                    disabled={grpApp || recurPopupSataus.status}
                    checked={recurrence}
                  />
                  &nbsp;
                </span>
                {recurrence ? (
                  <Link>
                    <span
                      onClick={() => setRecurrencePopup(!recurrencePoup)}
                      className="book-appt-check-val"
                    >
                      Recurrence
                    </span>
                  </Link>
                ) : (
                  <span className="book-appt-check-val">Recurrence</span>
                )}

                <div style={{ display: recurrencePoup ? 'block' : 'none' }}>
                  {recurrence && (
                    <RecurrencePopup
                      key={allDataSet?.editRecurringInfo?.recurrence_type}
                      handleRecurClose={() => {
                        setRecurrencePopup(!recurrencePoup);
                        //setRecurrence(false);
                      }}
                      handleAppDate={handleAppDate}
                      appDate={appDate}
                      handleRecurranceFormData={handleRecurranceFormData}
                      recurData={allDataSet?.editRecurringInfo}
                    />
                  )}
                </div>
              </div>
              <div className="appt-check-sec" style={{ display: 'flex' }}>
                <span
                  className="book-appt-check"
                  style={{ marginRight: '10px' }}
                >
                  <input
                    type="checkbox"
                    onChange={handleGrpAppOnAppPopUp}
                    checked={grpAppChkBox}
                    disabled={recurrence || recurPopupSataus.status}
                  />
                  &nbsp;
                </span>
                <span
                  className="book-appt-check-val"
                  onClick={() => (grpApp ? setGrpAppOnAppPopup(true) : null)}
                >
                  Group Appt ({grpAppPats ? grpAppPats.length : 0})
                </span>

                {grpAppOnAppPopup && (
                  <GroupAppPatPopUp
                    handleOpenPatSerch={handleOpenPatSerch}
                    handleGrpAppClose={handleGrpAppClosed}
                  />
                )}
              </div>
              <div className="appt-check-sec hide">
                <span className="book-appt-check">
                  <input type="checkbox" className="" />
                </span>
                <span className="book-appt-check-val">Approval Required:</span>
              </div>
            </div>
            <div className="appt-hx-fa-rw">
              <span className="label">
                Location:<span className="required-fld">*</span>
              </span>
              <span className="value">
                <select
                  className="book-appt-dd"
                  value={location || 0}
                  onChange={handleLocationChange}
                >
                  <option value="0"></option>
                  {allLocation &&
                    allLocation.map((item, idx) => (
                      <option key={idx} value={item?.id}>
                        {item?.location_code}
                      </option>
                    ))}
                </select>
              </span>
            </div>
            <div className="appt-hx-fa-rw">
              <span className="label">
                Resource:<span className="required-fld">*</span>
              </span>
              <span className="value">
                <select
                  className="book-appt-dd"
                  value={resource || ''}
                  onChange={(e) =>
                    handleResourceChange(e.target.value, globalAppId)
                  }
                >
                  <option value=""></option>
                  {allRresource &&
                    allRresource.map((item, idx) => (
                      <option key={idx} value={item?.id}>
                        {item?.fullName}
                      </option>
                    ))}
                </select>
              </span>
            </div>
            <div className="appt-hx-fa-rw">
              <span className="label">
                Provider:<span className="required-fld">*</span>
              </span>
              <span className="value">
                <select
                  className="book-appt-dd"
                  value={provider || ''}
                  onChange={(e) => setProvider(e.target.value)}
                >
                  <option value=""></option>
                  {allProvider &&
                    allProvider.map((item, idx) => (
                      <option key={idx} value={item?.id}>
                        {item?.fullName}
                      </option>
                    ))}
                </select>
              </span>
            </div>
            <div className="appt-hx-fa-rw">
              <span className="label">
                Date:<span className="required-fld">*</span>
              </span>
              <span
                className="value"
                style={{ display: 'flex', alignItems: 'center' }}
              >
                <ReactDatePicker
                  selected={appDate}
                  onChange={(date) => setAppDate(date)}
                  onClickOutside={openDatePicker}
                  open={appDatePickerIsOpen}
                  onSelect={handleDateSelect}
                  className="app-date-picker"
                  filterDate={filterDateForPicker}
                  dateFormat={DEFAULT_DATE_FORMATE}
                  excludeDates={holidayList}
                  highlightDates={highlightWithRanges}
                  renderDayContents={(day, date) => {
                    if (holidayList.includes(date)) {
                      return <span title={''}>{getDate(date)}</span>;
                    } else return getDate(date);
                  }}
                  disabled={
                    globalAppId && !bookNewApp?.status && originalAppDate &&
                    isBefore(
                      new Date(originalAppDate).setHours(0, 0, 0, 0),
                      new Date().setHours(0, 0, 0, 0),
                    )
                  }
                  maxDate={calculatedMaxDate}
                />
                <img
                  width="10%"
                  src="./images/calendar-icon.png"
                  alt=""
                  onClick={openDatePicker}
                  style={{ marginLeft: '10px' }}
                />
                <div className="appt-check-sec" style={{ width: '100%' }}>
                  <span className="book-appt-check-val">Appt. color</span>{' '}
                  <span
                    className="appt-colr-inpt"
                    onClick={() => setColorPalette(true)}
                    style={{ backgroundColor: `${appColor}`, height: '10px' }}
                  >
                    &nbsp;
                  </span>
                  {colorPalette && (
                    <ColorPalette
                      colorData={allDataSet?.color}
                      handleColorPaletteClose={() => setColorPalette(false)}
                      pickScheduleColor={pickScheduleColor}
                    />
                  )}
                </div>
              </span>
            </div>
            <div className="appt-hx-fa-rw">
              <span className="label">
                Time:<span className="required-fld">*</span>
              </span>
              <span
                className="app-time-picker"
                style={{ display: 'flex', alignItems: 'center', width: '58%' }}
              >
                {warnigImg.status && <>{warnigImg.img}</>}
                {/* <input type="text" className="apptTime" placeholder="HH:MM AM" /> */}
                <ReactDatePicker
                  selected={appTime}
                  //onChange={(date) => setAppTime(date)}
                  onClickOutside={openTimePicker}
                  onChange={(date) => handlTimeSelect(date)}
                  open={appTimePickerIsOpen}
                  showTimeSelect
                  showTimeSelectOnly
                  timeIntervals={15}
                  timeCaption="Time"
                  // dateFormat="h:mm aa"
                  dateFormat={
                    defaultTimeFormat?.withoutSecond === 'HH:mm'
                      ? 'HH:mm'
                      : 'h:mm aa'
                  } // Conditional date format
                  timeFormat={
                    defaultTimeFormat?.withoutSecond === 'HH:mm'
                      ? 'HH:mm'
                      : undefined
                  } // Conditional time format
                  placeholderText="00:00"
                  className="app-date-picker"
                  excludeTimes={providersBreak}
                  minTime={appMinTime}
                  maxTime={appMaxTime}
                  //disabled={editFlag}
                />
                <span
                  className="apptDate-time#"
                  style={{ marginRight: '5px', marginLeft: '10px' }}
                >
                  <AccessTimeIcon
                    fontSize="small"
                    color="orange"
                    sx={{ color: 'orange' }}
                    onClick={openTimePicker}
                  />
                  {/* <span className="apptDate-time-1">&nbsp;</span>
                <span className="apptDate-time-2">&nbsp;</span> */}
                </span>
                <Link onClick={handleSuggestTime}>suggest</Link>
                <span className="red clear-left5">|</span>
                <Link onClick={handleTimeslotPopup}>Slots</Link>
                {/* <TimeSlotAppPopup /> */}
                {/* {timeSlotPopup && (
                <TimeSlot
                  resource={resource}
                  appDate={appDate}
                  location={location}
                  addThisTimeSlot={addThisTimeSlot}
                  closeTimeShlot={() => setTimeSlotPopup(false)}
                />
              )} */}
              </span>
            </div>
            <div className="appt-hx-fa-rw">
              <span className="label">
                Type of visit:<span className="required-fld">*</span>
              </span>
              <span className="value">
                <select
                  className="book-appt-dd"
                  value={typeOfVisit || ''}
                  onChange={handleTypeOfVisit}
                >
                  <option value=""></option>
                  {typeOfVisitList &&
                    typeOfVisitList.map((item, idx) => (
                      <option key={idx} value={item?.id}>
                        {item?.visit_type}
                      </option>
                    ))}
                </select>
              </span>
            </div>
            <div className="appt-hx-fa-rw">
              <span className="label">
                Duration:<span className="required-fld">*</span>
              </span>
              <span className="value">
                <select
                  ref={durationRef}
                  className="book-appt-dd"
                  value={duration || ''}
                  onChange={handleDuration}
                >
                  {allDataSet?.allDuration &&
                    allDataSet?.allDuration.map((item, idx) => (
                      <option key={idx} value={item?.id}>
                        {item?.duration} Mins
                      </option>
                    ))}
                </select>
              </span>
            </div>
            <div className="appt-hx-fa-rw">
              <span className="label">
                Payment Type:<span className="required-fld">*</span>
              </span>
              <span className="value">
                <select
                  className="book-appt-dd"
                  value={typeOfPayment || ''}
                  onChange={(e) => setTypeOfPayment(e.target.value)}
                >
                  <option value=""></option>
                  {allTypeOfPayment &&
                    allTypeOfPayment.map((item, idx) => (
                      <option key={idx} value={item?.id}>
                        {item?.title}
                      </option>
                    ))}
                </select>
              </span>
            </div>
            <div className="appt-hx-fa-rw">
              <span className="label">PCP:</span>
              <span className="value">
                <select
                  className="book-appt-dd"
                  value={pcp || ''}
                  onChange={(e) => setPcp(e.target.value)}
                >
                  <option value=""></option>
                  {allDataSet?.pcpList &&
                    allDataSet?.pcpList.map((item, idx) => (
                      <option key={idx} value={item?.id}>
                        {item?.name}
                      </option>
                    ))}
                </select>
              </span>
            </div>
            <div className="appt-hx-fa-rw">
              <span className="label">Referral?:</span>
              <span className="value">
                <input
                  type="checkbox"
                  className="clear-top5"
                  onChange={handleNewReferral}
                  value={newReferral}
                  checked={newReferral === '1' ? true : false}
                />
                &nbsp;&nbsp; Yes
              </span>
            </div>
            <div className="appt-hx-fa-rw hide">
              <span className="book-appt-check">
                <input type="checkbox" className="clear-left15" />
              </span>
              <span className="book-appt-check-val clear-left5">
                New Referral?
              </span>
            </div>
            <div className="appt-hx-fa-rw">
              <span className="label">Summary Care Received:</span>
              <span className="value">
                <select
                  className="book-appt-dd"
                  disabled={enableScr ? '' : 'disabled'}
                  value={sumCareRec || ''}
                  onChange={(e) => setSumCareRec(e.target.value)}
                >
                  <option value=""></option>
                  {allDataSet?.summaryCareReceived &&
                    allDataSet?.summaryCareReceived.map((item, idx) => (
                      <option key={idx} value={item?.id}>
                        {item?.val}
                      </option>
                    ))}
                </select>
              </span>
            </div>
            <div className="appt-hx-fa-rw">
              <span className="label">Ref. Provider:</span>
              <span className="value">
                <select
                  className="book-appt-dd"
                  disabled={enableScr ? '' : 'disabled'}
                  value={refProvider || ''}
                  onChange={(e) => setRefProvider(e.target.value)}
                >
                  <option value=""></option>
                  {allDataSet?.refList &&
                    allDataSet?.refList.map((item, idx) => (
                      <option key={idx} value={item?.id}>
                        {item?.name}
                      </option>
                    ))}
                </select>
              </span>
            </div>
            <div className="appt-hx-fa-rw">
              <span className="label">Reason:</span>
              <span className="value">
                <textarea
                  className="book-appt-area"
                  placeholder="Write here..."
                  onChange={(e) => setReason(e.target.value)}
                  value={reason}
                ></textarea>
              </span>
            </div>
            {allDataSet?.accessIntakeForm === '1' && (
              <div>
                <span className="label">Intake forms:</span>
                <span>
                  <span className="value">
                    <input
                      type="checkbox"
                      className="clear-top5"
                      onChange={() =>
                        intakeForms === '0'
                          ? (setIntakeForms('1'), setReopenFlag('1'))
                          : (setIntakeForms('0'), setReopenFlag(false))
                      }
                      value={intakeForms}
                      checked={intakeForms === '1' ? true : false}
                    />
                  </span>
                </span>
                {intakeForms === '1' && reopenFlag && (
                  <span
                    className="link-color"
                    style={{ cursor: 'pointer' }}
                    onClick={() => setReopenFlag('1')}
                  >
                    [Reopen]
                  </span>
                )}
              </div>
            )}
          </div>
          {
            <IntakeFormsPopup
              hide={
                intakeForms === '0' ? 'hide' : reopenFlag === '1' ? '' : 'hide'
              }
              intakeFormList={allDataSet?.intakeFormList}
              checkedIds={checkedIds}
              setCheckedIds={setCheckedIds}
              setReopenFlag={setReopenFlag}
              handleIntakeFormPreview={(intakecatId, parentId) => {
                // setDocsUri(uri);
                // setIntakeFromPreviewPopup(true);
                const url =
                  DEFAULT_API_URL +
                  '/registration/intakeForm/index/' +
                  intakecatId +
                  '/' +
                  parentId +
                  '/' +
                  resource;
                window.open(url, '_blank', 'noopener,noreferrer');
              }}
            />
          }
          <div id="freeSlotsgstApntmnt" style={{ width: '60%' }}>
            {(() => {
              if (
                user?.glsstsettins?.ch_default_appointment_slot_chart === '1'
              ) {
                //return <TimeSlotAppPopup />;
                return (
                  <AppCalander
                    key={location}
                    providerId={resource || 0}
                    appDate={appDate}
                    originalAppDate={originalAppDate}
                    callback={(dateTime) => {
                      if (
                        Date.parse(
                          format(new Date(appDate), DEFAULT_DATE_FORMATE),
                        ) !== Date.parse(format(dateTime, DEFAULT_DATE_FORMATE))
                      ) {
                        setAppDate(dateTime);
                      }
                      setAppTime(dateTime);
                    }}
                    facilityList={allDataSet?.clinicData}
                    facilityLoc={location}
                    mode={mode}
                    setMode={setMode}
                  />
                );
              } else {
                return (
                  <TimeSlot
                    resource={resource}
                    appDate={appDate}
                    location={location}
                    addThisTimeSlot={addThisTimeSlot}
                    closeTimeShlot={() => setTimeSlotPopup(false)}
                  />
                );
              }
            })()}
          </div>
        </div>
        <span className="logout-action flex-sec justify-between item-center">
          <div>
            <span onClick={handleGoToAppList}>
              <Link>Main scheduler</Link>
            </span>
          </div>
          <div className="flex-sec gap10">
            <Button variant="outline" onClick={handleClose}>
              Cancel
            </Button>
            {(() => {
              if (appReschedule.status) {
                return (
                  <Button variant="primary" onClick={handleAppReschedule}>
                    Save
                  </Button>
                );
              } else if (globalAppId && !bookNewApp.status) {
                return recurrence ? (
                  <Button variant="primary" onClick={handleRecurAppUpdate}>
                    Update
                  </Button>
                ) : (
                  <Button variant="primary" onClick={handleAppUpdate}>
                    Update
                  </Button>
                );
              } else {
                return (
                  <Button variant="primary" onClick={handleAppSave}>
                    Save
                  </Button>
                );
              }
            })()}
          </div>
        </span>
      </div>

      {checkAppExist && (
        <ConfirmDialog
          title={'Confirm'}
          bodytext={
            <div dangerouslySetInnerHTML={{ __html: checkAppBodyText }} />
          }
          closeDialog={() => setCheckAppExist(false)}
          successDialog={
            appReschedule.status
              ? handleRescheduleConfirm
              : handleAppSaveConfirm
          }
          //sucPrams={sucPrams}
        />
      )}

      {confirmBlockedApp.status && (
        <ConfirmDialog
          title={'Confirm'}
          bodytext={
            'The date & time is outside the provider’s schedule; do you want to continue?'
          }
          closeDialog={() =>
            setConfirmBlockedApp((preVal) => {
              return {
                ...preVal,
                status: false,
                data: '',
                type: '',
              };
            })
          }
          successDialog={() => {
            if (confirmBlockedApp.type === 'save') {
              return handleAppSaveConfirm();
            }
            if (confirmBlockedApp.type === 'update') {
              return handleAppUpdate();
            }
          }}
        />
      )}
      {alertPopup && (
        <ViewAlertPopup
          alertData={patAlertData}
          patientId={selPatForApp}
          close={() => setAlertPopup(false)}
        />
      )}
      {/* {intakeFromPreviewPopup && (
        <IntakeFormsViewer
          close={() => setIntakeFromPreviewPopup(false)}
          docsUri={docsUri}
        />
      )} */}

      {alertDialoguePopup && (
        <AlertDialog
          title="Alert"
          bodytext={alertDialogueMsg}
          successDialog={() => setAlertDialoguePopup(false)}
        />
      )}
    </div>
  );
}

export default AppPopup;
